"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RmqProviderType = void 0;
var RmqProviderType;
(function (RmqProviderType) {
    RmqProviderType["EML_SERVICE"] = "EML_SERVICE";
})(RmqProviderType || (exports.RmqProviderType = RmqProviderType = {}));
//# sourceMappingURL=provider.js.map